import { render, staticRenderFns } from "./CurrentData.vue?vue&type=template&id=6202b4f8&scoped=true&"
import script from "./CurrentData.vue?vue&type=script&lang=js&"
export * from "./CurrentData.vue?vue&type=script&lang=js&"
import style0 from "./CurrentData.vue?vue&type=style&index=0&id=6202b4f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202b4f8",
  null
  
)

export default component.exports